/**
 * Communication Services
 * Services for email, SMS, push notification, WhatsApp, and device operations
 */
// Export services (classes only, not internal types)
export { EmailService } from './EmailService';
export { SmsService } from './SmsService';
export { PushNotificationService } from './PushNotificationService';
export { WhatsAppService } from './WhatsAppService';
export { TemplateService } from './TemplateService';
export { DeviceService } from './DeviceService';
// Import for factory
import { EmailService } from './EmailService';
import { SmsService } from './SmsService';
import { PushNotificationService } from './PushNotificationService';
import { WhatsAppService } from './WhatsAppService';
import { TemplateService } from './TemplateService';
import { DeviceService } from './DeviceService';
/**
 * Factory function to create all communication services
 * @param http - HTTP client instance
 * @param config - Optional service configuration
 */
export function createCommunicationServices(http, config) {
    return {
        email: new EmailService(http, config),
        sms: new SmsService(http, config),
        pushNotification: new PushNotificationService(http, config),
        whatsApp: new WhatsAppService(http, config),
        template: new TemplateService(http, config),
        device: new DeviceService(http, config),
    };
}
//# sourceMappingURL=index.js.map